// extracted by mini-css-extract-plugin
export default {"validatingStatus":"ValidatingStatus_validatingStatus__EivVE","loader":"ValidatingStatus_loader__xnc0a"};